import { useState } from "react";
import { useRecoilValue } from "recoil";

import OddConverter from "@common/helpers/oddConverter";

import NumericInput from "src/common/components/numericInput";
import { decimalString } from "src/constants/types";
import { useTranslation } from "src/hooks/translation";
import upperDataStore from "src/stores/upperData";
import { useConfig } from "src/hooks/config";

import "./style.scss";

interface IProps {
	value: decimalString;
	onChange(value: decimalString): void;
	onMaxClick(): void;
	className?: string;
	placeholder?: string;
	maxOdd?: number;
}

const OddInput = ({ value, onChange, onMaxClick, className, placeholder }: IProps) => {
    const t = useTranslation();
    const config = useConfig();
    const { oddsFormat } = useRecoilValue(upperDataStore);
    const [isOpen, setIsOpen] = useState(false)
    
    return (
        <div className={`B-odd-input-wrapper ${className || ''}`}>
            <NumericInput
                value={isOpen ? value : OddConverter(config, value, oddsFormat)}
                placeholder={t(placeholder || 'Price')}
                onChange={onChange}
                toggleKeyboard={() => setIsOpen(!isOpen)}
                className={className}
                maxDecimalCount={2}
                maxLength={7}
            />

            <div className="B-odd-input-btns">
                {!!value && <i
                    className="B-odd-clear icon-circle-close"
                    onClick={() => onChange('')}
                />}

                <button className="B-inp-max" onClick={onMaxClick}>{t('Max')}</button>
            </div>
        </div>
    );
};

export default OddInput;
